import { SPACER_HEIGHT } from "~/components/build/Show/pages/steps/list/components/constants";
import { TreeNode } from "~/components/build/Show/pages/steps/list/components/TreeNode";

export function createSpacerNode(id: string): TreeNode {
  return {
    id,
    height: SPACER_HEIGHT,
    ariaHidden: true,
    render: () => null,
  };
}
